import { useState } from 'react';

export const useCopyInputEditMode = () => {
  const [editMode, setEditMode] = useState(false);

  return {
    editMode,
    setEditMode,
  };
};
